import { SET_BRAND, LOGOUT } from './types'

export const setBrand = (payload) => ({
  type: SET_BRAND,
  payload,
})

export const logout = () => ({
  type: LOGOUT,
});
